// NoteView has been decomposed into a Views/Note/ folder. This root file stays as a
// thin composer that re-exports the public API so existing `./NoteView` import paths
// (CruiseView / DayView / TripView and the view tests) keep working unchanged.

export { NoteTypeIcon, NoteViewData } from "./Note/Context"
export { NoteTabs, NotesView } from "./Note/NotesView"
export { NoteView } from "./Note/NoteView"
